export default __webpack_public_path__ + "static/media/compass6.e24fb731.png";